(function (global) {
  'use strict';
  function percent(value) { return Math.max(0, Math.min(100, Number(value) || 0)); }
  function discounted(price, value) { return Math.round(Number(price) * (100 - percent(value)) / 100); }
  function config(section) {
    var node = section.querySelector('[data-cl-offers]');
    return node ? node.dataset : {};
  }
  function rate(section) {
    if (section.dataset.clAutomaticDiscounts === 'true') return 0;
    var settings = config(section);
    return (settings.clDiscountCode || '').trim() ? percent(settings.clDiscountPercent) : 0;
  }
  function price(section, cents) { return discounted(cents, rate(section)); }
  function packageName(value) { return String(value || '').trim().toLowerCase().replace(/\s+bundle$/, ''); }
  function update(section, title, available, money) {
    var settings = config(section);
    var unlocked = available && packageName(title) === packageName(settings.clRewardPackage);
    section.querySelectorAll('[data-cl-reward]').forEach(function (node) {
      node.classList.toggle('is-unlocked', !!unlocked);
      node.querySelector('[data-cl-reward-state]').textContent = unlocked ? 'Unlocked' : 'Locked';
      node.querySelector('[data-cl-reward-icon]').textContent = unlocked ? '✓' : '＋';
    });
    section.querySelectorAll('[data-cl-reward-hint]').forEach(function (hint) {
      hint.textContent = unlocked ? 'Rewards unlocked' : 'Select ' + (settings.clRewardPackage || 'Squad Bundle') + ' to unlock';
    });
    section.querySelectorAll('[data-cl-addon]').forEach(function (addon) {
      var input = addon.querySelector('[data-cl-addon-input]');
      var current = addon.querySelector('[data-cl-offer-price]');
      var original = addon.querySelector('[data-cl-offer-original]');
      var badge = addon.querySelector('[data-cl-offer-badge]');
      if (!input || !current) return;
      var base = Number(input.dataset.clAddonPrice) || 0;
      current.textContent = input.disabled ? '' : (addon.dataset.clAddonPricePrefix || '+') + money(price(section, base));
      original.hidden = !rate(section) || input.disabled;
      original.textContent = money(base);
      badge.hidden = original.hidden;
      badge.textContent = rate(section) + '% off';
    });
  }
  function cartUrl(section, hasAddons) {
    if (section.dataset.clAutomaticDiscounts === 'true') return section.dataset.clCartUrl;
    var code = (config(section).clDiscountCode || '').trim();
    var cart = section.dataset.clCartUrl;
    return hasAddons && rate(section) > 0
      ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cart)
      : cart;
  }
  // Add-on code for the managed Ajax discount flow (same eligibility rule as cartUrl).
  function addonCode(section, hasAddons) {
    if (section.dataset.clAutomaticDiscounts === 'true') return '';
    var code = (config(section).clDiscountCode || '').trim();
    return hasAddons && rate(section) > 0 ? code : '';
  }
  var api = { addonCode: addonCode, percent: percent, discounted: discounted, rate: rate, price: price, update: update, cartUrl: cartUrl };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  global.ClutchLoopOffers = api;
})(typeof window !== 'undefined' ? window : globalThis);
